function CourseDetail({ icon, title, value, price, discount }) {
    // To Do
    // if (value === 0) return null;

    return (
        <p
            className={`flex items-center  text-secondary-color
      `}
        >
            <span className="ml-2 mr-2">{icon}</span>
            {title} :{" "}
            <span
                className={`px-2 ${
                    discount >= 0 ? "text-green-color" : "text-secondary-color"
                }`}
            >
                {value === 0 || value === "00:00:00" ? "لا يوجد" : value}{" "}
                {discount && " جنية"}
            </span>
            {discount > 0 && (
                <span className="px-2 line-through text-secondary-color-color ">
                    بدلا من {price + discount} جنية
                </span>
            )}
        </p>
    );
}

export default CourseDetail;
